import React from "react";
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }
  componentDidCatch(error, errorInfo) {
    this.setState({
      hasError: true
    });
  }
  handleCache = () => {
    caches.keys().then(names => {
      names.forEach(name => {
        caches.delete(name);
      });
    });
    localStorage.clear();
    window.location.href = "/login";
  };
  render() {
    if (this.state.hasError) {
      return (
        <div className="errorDiv">
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ marginBottom: "25px" }}>
              <img
                id="main-logo"
                className="mr-1"
                style={{ maxWidth: "50px" }}
                src={require("../src/images/bitcoin-live/logo.png")}
                alt="Bitcoin Live"
              />
            </div>
            <div
              style={{
                display: "flex",
                flexFlow: "column",
                justifyContent: "center"
              }}
            >
              <div
                style={{
                  fontStyle: "normal",
                  fontWeight: "bold",
                  fontSize: "18px",
                  lineHeight: "22px",
                  color: "#FAA61A"
                }}
              >
                BITCOIN
              </div>
              <div
                style={{
                  fontStyle: "normal",
                  fontWeight: "bold",
                  fontSize: "14px",
                  lineHeight: "17px",
                  color: "#FAA61A"
                }}
              >
                LIVE
              </div>
            </div>
          </div>
          <p style={{ textAlign: "center" }}>
            Loading failed !{" "}
            <label
              onClick={this.handleCache}
              style={{ color: "#F1591E", cursor: "pointer" }}
            >
              {" "}
              Click here to reload
            </label>{" "}
            or write us in support.
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
